import React from 'react';
import { getImageAssetUrl } from '../../../utils/assetUtils.js';
import { ArrowLink } from './ArrowLink.js';
import { ProductPageDialogContent } from './ProductPageDialogContent.js';

const ProductPageDialogSuccess = ({ closeDialogText, redirectionText, redirectionUrl, handleClose, }) => {
    return (React.createElement(ProductPageDialogContent, { showIcon: true, iconProps: {
            src: getImageAssetUrl('icon_success_tick.webp'),
            alt: 'success',
            style: { width: 124, height: 124 },
        }, title: "Success!", subtitle: "We sent a text message with a link to download Brandclub and access your rewards." },
        closeDialogText && React.createElement(ArrowLink, { text: closeDialogText, onTextClick: handleClose }),
        redirectionText && redirectionUrl && (React.createElement(ArrowLink, { text: redirectionText, url: redirectionUrl, onTextClick: () => window.open(redirectionUrl, '_blank') }))));
};

export { ProductPageDialogSuccess };
//# sourceMappingURL=ProductPageDialogSuccess.js.map
